import events from '../events/events';

const Chatbox = {};

/**
 * Chatbox plugin
 *
 * @param Vue
 * @param options
 */
Chatbox.install = function(Vue, options)
{
    let methods =
    {
        open(event, payload)
        {
            events.$emit('toolbox.open', 'chatbox', event, payload);
        },

        openItem(event, payload)
        {
            events.$emit('toolbox.open', 'itemchatbox', event, payload);
        },

        close()
        {
            events.$emit('toolbox.close');
        },
    };

    // register global methods
    Vue.chatbox = methods;

    // register instance methods
    Vue.prototype.$chatbox = methods;
};

export default Chatbox;



// WEBPACK FOOTER //
// ./src/js/plugins/chatbox.js